export default "__VITE_ASSET__BRHkparS__"